// src/utils/service-mapping.js

export const backendToFrontendService = {
  services_test_TB: "tb_screening",
  services_test_HIV: "ptv",
  exchange_distribution_of_syringes: "syringe_exchange",
  dispensing_contraceptives: "condom_distribution",
  consultation: "information_services",
};

export const serviceColors = {
  tb_screening: "#FF5733",
  ptv: "#33B5FF",
  syringe_exchange: "#8D33FF",
  condom_distribution: "#2f823d",
  information_services: "#FF9800",
};

export const serviceLabels = {
  tb_screening: "Скринінг на туберкульоз",
  ptv: "Тестування на ВІЛ",
  syringe_exchange: "Обмін шприців",
  condom_distribution: "Презервативи",
  information_services: "Інформаційні послуги",
};
